import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/kcjs1",
      name: "kcjs1",
      redirect: { name: "courseDetails" }
    },
    {
      path: "/jsjs1",
      name: "jsjs1",
      redirect: { name: "courseDetails" }
    },
    {
      path: "/kcjs2",
      name: "kcjs2",
      redirect: { name: "projectdetails" }
    },
    {
      path: "/jsjs2",
      name: "jsjs2",
      redirect: { name: "projectdetails" }
    },
    {
      path: "",
      redirect: { name: "home" }
    },
    {
      path: "/login",
      name: "login",
      component: resolve => require(["@/views/userlogin"], resolve)
    },
    {
      path: "/userlogin",
      name: "userlogin",
      component: resolve => require(["@/views/userlogin"], resolve)
    },
    {
      path: "/managelogin",
      name: "managelogin",
      component: resolve => require(["@/views/managelogin"], resolve)
    },
    {
      path: "/film",
      name: "film",
      component: resolve =>
        require(["@/views/man/liveVideoManage/film"], resolve)
    },
    {
      path: "/manage",
      name: "manage",
      component: resolve => require(["@/views/man/manage"], resolve),
      children: [
        {
          path: "/",
          name: "manage",
          component: resolve =>
            require(["@/views/man/courseManage/courseManage"], resolve)
        },
        {
          path: "courseManage",
          name: "课程管理",
          component: resolve =>
            require(["@/views/man/courseManage/courseManage"], resolve)
        },
        {
          path: "courseManage/addCourseVideo",
          name: "新增课程视频",
          component: resolve =>
            require(["@/views/man/courseManage/addCourseVideo"], resolve)
        },
        {
          path: "courseManage/courseDetail",
          name: "课程详情",
          component: resolve =>
            require(["@/views/man/courseManage/courseDetail"], resolve)
        },
        {
          path: "courseManage/courseEdit",
          name: "课程编辑",
          component: resolve =>
            require(["@/views/man/courseManage/courseEdit"], resolve)
        },
        {
          path: "courseManage/courseAdd",
          name: "课程新增",
          component: resolve =>
            require(["@/views/man/courseManage/courseAdd"], resolve)
        },
        {
          path: "liveVideoManage",
          name: "直播视频管理",
          component: resolve =>
            require(["@/views/man/liveVideoManage/liveVideoManage"], resolve)
        },
        {
          path: "liveVideoManage/liveVideoDetail",
          name: "直播视频详情",
          component: resolve =>
            require(["@/views/man/liveVideoManage/liveVideoDetail"], resolve)
        },
        {
          path: "liveVideoManage/liveVideoEdit",
          name: "直播视频编辑",
          component: resolve =>
            require(["@/views/man/liveVideoManage/liveVideoEdit"], resolve)
        },
        {
          path: "projectManage",
          name: "专题管理",
          component: resolve =>
            require(["@/views/man/projectManage/projectManage"], resolve)
        },
        {
          path: "projectManage/addPro",
          name: "新增专题",
          component: resolve =>
            require(["@/views/man/projectManage/addPro"], resolve)
        },
        {
          path: "projectManage/editPro",
          name: "编辑专题",
          component: resolve =>
            require(["@/views/man/projectManage/editPro"], resolve)
        },
        {
          path: "projectManage/detail",
          name: "专题详情",
          component: resolve =>
            require(["@/views/man/projectManage/detail"], resolve)
        },
        {
          path: "projectManage/addSpecialVideo",
          name: "上传专题视频",
          component: resolve =>
            require(["@/views/man/projectManage/addSpecialVideo"], resolve)
        },
        {
          path: "lecturerManage",
          name: "讲师管理",
          meta:{
            keepAlive:true
          },
          component: resolve =>
            require(["@/views/man/lecturerManage/lecturerManage"], resolve)
        },
        {
          path: "lecturerManage/lecturerDetail",
          name: "讲师管理详情",
          component: resolve =>
            require(["@/views/man/lecturerManage/lecturerDetail"], resolve)
        },
        {
          path: "lecturerManage/lecturerEdit",
          name: "讲师管理编辑",
          component: resolve =>
            require(["@/views/man/lecturerManage/lecturerEdit"], resolve)
        },
        {
          path: "courseReview",
          name: "视频审核",
          component: resolve =>
            require(["@/views/man/courseReview/courseReview"], resolve)
        },
        {
          path: "courseReview/courseReviewDetail",
          name: "视频审核详情",
          component: resolve =>
            require(["@/views/man/courseReview/courseReviewDetail"], resolve)
        },
        {
          path: "studentLearning",
          name: "学生学习情况",
          component: resolve =>
            require(["@/views/man/studentLearning/studentLearning"], resolve)
        },
        {
          path: "studentLearning/stuLearnDetail",
          name: "学生学习情况详情",
          component: resolve =>
            require(["@/views/man/studentLearning/stuLearnDetail"], resolve)
        },
        {
          path: "setting",
          name: "setting",
          component: resolve => require(["@/views/man/setting"], resolve),
          children: [
            {
              path: "/",
              name: "studentConfiguration",
              component: resolve =>
                require(["@/views/man/setting/studentConfiguration"], resolve)
            },
            {
              path: "studentConfiguration",
              name: "studentConfiguration",
              component: resolve =>
                require(["@/views/man/setting/studentConfiguration"], resolve)
            },
            {
              path: "courseScheduleConfiguration",
              name: "courseScheduleConfiguration",
              component: resolve =>
                require([
                  "@/views/man/setting/courseScheduleConfiguration"
                ], resolve)
            },
            {
              path: "lecturerConfiguration",
              name: "lecturerConfiguration",
              component: resolve =>
                require(["@/views/man/setting/lecturerConfiguration"], resolve)
            },
            {
              path: "classType",
              name: "classType",
              component: resolve =>
                require(["@/views/man/setting/classType"], resolve)
            },
            {
              path: "power",
              name: "power",
              component: resolve =>
                require(["@/views/man/setting/power"], resolve)
            },
            {
              path: "banner",
              name: "banner",
              component: resolve =>
                require(["@/views/man/setting/banner"], resolve)
            },
            {
              path: "user",
              name: "settingsUser",
              component: resolve =>
                require(["@/views/man/setting/user"], resolve)
            }
          ]
        },
        {
          path: "studentSeeRecord",
          component: resolve =>
            require(["@/views/man/studentSeeRecord"], resolve)
        },
        {
          path: "classEvaluate",
          component: resolve => require(["@/views/man/classEvaluate"], resolve)
        }
      ]
    },
    {
      path: "/user",
      name: "user",
      component: resolve => require(["@/views/user/User"], resolve),
      children: [
        {
          path: "",
          name: "home",
          component: resolve => require(["@/views/user/Home"], resolve)
        },
        {
          path: "home",
          name: "home",
          component: resolve => require(["@/views/user/Home"], resolve)
        },
        {
          path: "all",
          name: "all",
          component: resolve => require(["@/views/user/All"], resolve),
        },
        {
          path: "myCourses",
          name: "myCourses",
          component: resolve => require(["@/views/user/MyCourses"], resolve)
        },
        {
          path: "personalCenter",
          name: "personalCenter",
          component: resolve =>
            require(["@/views/user/PersonalCenter"], resolve)
        },
        {
          path: "courseDetails",
          name: "courseDetails",
          component: resolve => require(["@/views/user/CourseDetails"], resolve)
        },
        {
          path: "projectdetails",
          name: "projectdetails",
          component: resolve => require(["@/views/user/projectdetails"], resolve)
        },
      ]
    }
  ]
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js